import { render, staticRenderFns } from "./MagicLinkContactMethods.vue?vue&type=template&id=1a12d71c&scoped=true&"
import script from "./MagicLinkContactMethods.vue?vue&type=script&lang=js&"
export * from "./MagicLinkContactMethods.vue?vue&type=script&lang=js&"
import style0 from "./MagicLinkContactMethods.vue?vue&type=style&index=0&id=1a12d71c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a12d71c",
  null
  
)

export default component.exports